/**
 * Determines which top level domain to use based on the current hostname
 * Compatible with Nuxt SSR and client-side rendering
 * Returns either 'queresto.com' or 'bistrify.com'
 * Defaults to 'queresto.com' if the hostname doesn't match any known domain
 *
 * @returns {string} The appropriate top level domain
 */
export function getTopLevelDomain(): string {
  const currentHostname = window.location.hostname.toLowerCase();

  // Check if the current hostname includes bistrify
  if (currentHostname.includes('bistrify')) {
    return 'bistrify.com';
  }

  // Default to queresto.com for all other cases
  return 'queresto.com';
}

/**
 * Replaces queresto.com with the correct top level domain
 * @param text
 */
export function fixTopLevelDomain(text: string): string {
  if (!text) return text;

  return text.replace('queresto.com', getTopLevelDomain());
}
